const noAccessState = {
    parent: 'root',
    url: '/noaccess',
    template: require('./noAccess/noAccess.html')
};

export default function (app) {
    app.config($stateProvider => {
        $stateProvider
            .state('noaccess', noAccessState);
    });

    app.run(($rootScope, securityConfig, $state) => {
        $rootScope.$on('$stateChangeStart',
        (event, toState) => {
            securityConfig(toState.data)
                .then(result => {
                    if (toState.data && toState.name && toState.name.toLowerCase() !== 'noaccess' && !result) {
                        event.preventDefault();
                        $state.go('noaccess');
                    }
                });
        });
    });
}



// WEBPACK FOOTER //
// ./Client/app/common/routes.js